import { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import Group from 'components/utils/Group'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import ContactContext from 'contexts/contactContext'

// TODO: refactor (https://aussiecommerce.atlassian.net/browse/CRUZ-2510)
function NeedHelp() {
  const currentContact = useContext(ContactContext)
  const supportContact = currentContact.defaultContact

  return (
    <Group gap={0} tabletGap={8} direction="vertical">
      <Heading variant="heading6">
        <FormattedMessage
          id="YNhjck1j_UdgvrAlaxdv"
          defaultMessage="Need help?"
          description="Heading for need help section on cruise page in the cruise section"
        />
      </Heading>
      <Group direction="vertical" desktopDirection="horizontal" gap="12 0" desktopGap="0 12">
        <BodyText variant="medium" colour="light-foreground-alt">
          <FormattedMessage
            id="oeU_9xvBwzgKjAZkCh6B"
            defaultMessage="Call our customer service team 24 hours, 7 days."
            description="Description for customer service availability in the cruises section"
          />
        </BodyText>
        <TextLink
          startIcon={<LinePhoneIcon />}
          size="medium"
          href={`tel:${supportContact.number}`}
        >
          {supportContact.humanReadable}
        </TextLink>
      </Group>
    </Group>
  )
}

export default NeedHelp
